<template>
  <table>
    <thead>
      <tr class="invoice-cost-tr">
        <th scope="col">Name</th>
        <th scope="col">Cost per hour</th>
        <th scope="col">Time</th>
        <th class="align-right" scope="col">Total cost</th>
        <th class="align-right" scope="col" width="2%"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(staffHour, index) in staffHours"
        :key="`staff-hour-${staffHour.id}-${index}`"
      >
        <td v-if="staffHour.staff_name?.length > 15">
          <NrTooltip :label="staffHour.staff_name">
            {{ truncate(staffHour.staff_name, { length: 15 }) }}
          </NrTooltip>
        </td>
        <td v-else>
          {{ staffHour.staff_name }}
        </td>
        <td>
          {{
            staffHour?.hourly_rate || staffHour?.staff_hourly_rate || '$0.00'
          }}
        </td>
        <td>{{ staffHour.staff_hour }}</td>
        <td class="align-right">{{ staffHour.staff_cost }}</td>
        <td>
          <InvoiceItemMenu
            @on-edit="onEdit(staffHour)"
            @on-delete="onDelete(staffHour)"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { mapMutations, mapState } from 'vuex'
import { RequestStaffHours } from '../types/invoice_line_items'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip'
import InvoiceItemMenu from './InvoiceItemMenu.vue'
import truncate from 'lodash/truncate'

export default {
  components: {
    InvoiceItemMenu,
    NrTooltip
  },

  computed: {
    ...mapState('request_show', ['requestStaffHours']),

    staffHours(): Array<RequestStaffHours> {
      const hours: { string: RequestStaffHours[] } = this.requestStaffHours
      return Object.values(hours)
        .flat()
        .filter(
          (staffHourItem: RequestStaffHours) =>
            staffHourItem.invoice_id == null &&
            !staffHourItem.exclude_time_on_invoice
        )
    }
  },

  methods: {
    ...mapMutations('request_show', ['setSelectedStaffHour', 'setActiveModal']),

    truncate,

    onEdit(staffHour: RequestStaffHours) {
      this.setSelectedStaffHour(staffHour)
      this.setActiveModal('editStaffTime')
    },

    onDelete(staffHour: RequestStaffHours) {
      this.setSelectedStaffHour(staffHour)
      this.setActiveModal('deleteStaffHourConfirmationDialog')
    }
  }
}
</script>
